// extracted by mini-css-extract-plugin
export var alt = "FooterLinks-module--alt--9c5d3";
export var desktopOnly = "FooterLinks-module--desktopOnly--33168";
export var footerContainer = "FooterLinks-module--footerContainer--fb2cf";
export var footerlinkHead = "FooterLinks-module--footerlinkHead--88a14";
export var footerlinkList = "FooterLinks-module--footerlinkList--3601b";
export var main = "FooterLinks-module--main--0c36a";
export var menu = "FooterLinks-module--menu--c000f";
export var mobileOnly = "FooterLinks-module--mobileOnly--29b20";
export var rowFooterLinks = "FooterLinks-module--rowFooterLinks--f4535";
export var show = "FooterLinks-module--show--2633c";
export var textLeft = "FooterLinks-module--textLeft--5e765";
export var visuallyHidden = "FooterLinks-module--visuallyHidden--5434f";